<template>
  <!-- Menú de estatus: vertical en desktop (lg+), tira horizontal en móvil —
       mismo patrón que el menú de Reportes. -->
  <nav
    class="bg-white rounded-lg shadow-primary p-2 flex lg:flex-col gap-1 overflow-x-auto w-full lg:w-56 shrink-0 lg:sticky lg:top-4"
  >
    <component
      v-for="option in options"
      :key="option.label"
      :is="option.to ? 'router-link' : 'button'"
      :to="option.to"
      class="status-nav-item shrink-0 text-left"
      :class="[
        option.active
          ? ['bg-primary-100 font-semibold', option.activeClass || 'text-primary-600']
          : 'text-content-400 hover:bg-gray-50 hover:text-content-500',
      ]"
      @click="option.to ? null : $emit('select', option.value)"
    >
      <span v-if="option.icon" class="mr-1.5">{{ option.icon }}</span
      >{{ option.label }}
    </component>
  </nav>
</template>

<script>
export default {
  name: "StatusSideNav",

  props: {
    // [{ label, active, activeClass?, to? }] — con `to` renderiza router-link;
    // sin `to` renderiza botón y emite 'select' con option.value.
    options: { type: Array, required: true },
  },

  emits: ["select"],
};
</script>

<style scoped>
.status-nav-item {
  display: block;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.15s;
}
</style>
